import {JoinHandlerInterface} from "@share/web-conferences/interfaces/JoinHandlerInterface";

export class ConnectionDropHandler {
    bindedOnlineHandler: any = null
    isReconnecting = false;

    constructor(
        private readonly joinHandler: JoinHandlerInterface
    ) {
        this.bindedOnlineHandler = this.onlineHandler.bind(this);
        window.addEventListener('online', this.bindedOnlineHandler);
    }

    /**
     * As of now (2021-03-27) in case when the token is expired and connection lost simultaneously
     * agora doesn't send the event that the token is expired nor the event that tells us about the restoring of the connection.
     * That's why if after 5 seconds since we got back online we check if the client is still trying to reconnect.
     * If it is we consider that status as token expired, but since we are in the reconnecting mode we can't just renew token.
     * That's why we leave the channel and join again
     */
    private onlineHandler() {
        setTimeout(async () => {
            if (this.joinHandler.agora.client.connectionState == 'RECONNECTING') {
                this.isReconnecting = true;
                await this.joinHandler.agora.leave();
                await this.joinHandler.agora.clean(false);
                if (this.joinHandler.shareClient.joined) {
                    await this.joinHandler.shareClient.leave();
                }
                await this.joinHandler.join();
                this.isReconnecting = false;
            }
        }, 5000);
    }

    clean(): void {
        window.removeEventListener('online', this.bindedOnlineHandler);
    }
}
